import {configureInputValidation} from '../../modules/helpers/thresholds-settings-helper';
import {createTokenField} from '../../modules/helpers/s2s_ip_sec_helper';
import debounce from 'lodash.debounce';
import {
  THRESHOLD_SETTINGS_INPUT_DEBOUNCE_MS, DEVICE_AND_JOB_THRESHOLD_SLIDER_VALUES, DEVICE_AND_JOB_THRESHOLD_SLIDER_BOUNDARY_VALUES,
  DEFAULT_SERVER_THRESHOLD_VALUE_MINUTES, DEFAULT_WORKSTATION_THRESHOLD_VALUE_MINUTES, LOCAL_CACHE_THRESHOLD_SLIDER_VALUES,
  LOCAL_CACHE_THRESHOLD_SLIDER_BOUNDARY_VALUES, DEFAULT_LOCAL_CACHE_THRESHOLD_VALUE_MINUTES
} from '../../modules/constants';
import {tabsGoTo, activeTabReload, tabReloadByElement} from '../../modules/single-page-app';

window.configureThresholdSliderInputValidation = configureInputValidation;
window.debounceFunction = debounce;
window.createTokenFieldS2SIPSec = createTokenField;
window.THRESHOLD_SETTINGS_INPUT_DEBOUNCE_MS = THRESHOLD_SETTINGS_INPUT_DEBOUNCE_MS;
window.DEVICE_AND_JOB_THRESHOLD_SLIDER_VALUES = DEVICE_AND_JOB_THRESHOLD_SLIDER_VALUES;
window.DEVICE_AND_JOB_THRESHOLD_SLIDER_BOUNDARY_VALUES = DEVICE_AND_JOB_THRESHOLD_SLIDER_BOUNDARY_VALUES;
window.DEFAULT_SERVER_THRESHOLD_VALUE_MINUTES = DEFAULT_SERVER_THRESHOLD_VALUE_MINUTES;
window.DEFAULT_WORKSTATION_THRESHOLD_VALUE_MINUTES = DEFAULT_WORKSTATION_THRESHOLD_VALUE_MINUTES;
window.LOCAL_CACHE_THRESHOLD_SLIDER_VALUES = LOCAL_CACHE_THRESHOLD_SLIDER_VALUES;
window.LOCAL_CACHE_THRESHOLD_SLIDER_BOUNDARY_VALUES = LOCAL_CACHE_THRESHOLD_SLIDER_BOUNDARY_VALUES;
window.DEFAULT_LOCAL_CACHE_THRESHOLD_VALUE_MINUTES = DEFAULT_LOCAL_CACHE_THRESHOLD_VALUE_MINUTES;

window.tabs_goto = tabsGoTo;
window.active_tab_reload = activeTabReload;
window.tab_reload_by_element = tabReloadByElement;
